import { Component, Input, OnInit } from '@angular/core';
import { TextContentService } from '../../../../core/services';

@Component({
    selector: 'rms-text-content-associated-map',
    templateUrl: './text-content-associated-map.component.html',
    styleUrls: ['./text-content-associated-map.component.scss'],
    standalone: false
})
export class TextContentAssociatedMapComponent implements OnInit {
  @Input() data: any;

  constructor(
    private textContentService: TextContentService
  ) { }

  ngOnInit() {
  }

  public openMapsModal(): void {
    this.textContentService.openAssociatedMapModal(this.data.id);
  }
}
